import { useTypeFraisByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";

function TypeFraisItem({type_frais_id}:{type_frais_id:string|number}){
   const { data, error, isLoading }= useTypeFraisByIdQuery(type_frais_id.toString());
    const {translate}=useTrads();
    return (
        error ? (
           <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p>

        ) : isLoading ? (
            <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p>
        ) : data ? (
        <span>{data.name}</span>
        ):null
    )
}
export default TypeFraisItem;